import { useBackend } from "../../services";

export const useGetDiscogsIdentity = () => {
  const { get } = useBackend();
  return async () => {
    return await get("discogs/identity");
  };
};
